import { Component, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import { CartTransactionService, PrettyCartTransaction, TransactionStatus, OrderStatusEnum } from '../services/cart-transaction.service';
import { CartService } from '../services/cart.service';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import { BlockUIWrapperComponent } from '../../layout/block-ui/block-ui-wrapper.component';
import { Subscription } from 'rxjs';
import flatpickr from 'flatpickr';
import { UtilsService } from '../../services/utils.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'purchases',
  templateUrl: './cart-purchases.component.html',
  styleUrls: ['./cart-purchases.component.css']
})
export class CartPurchasesComponent implements OnInit, OnDestroy {
  input: any = {};
  transactions: PrettyCartTransaction[] = [];
  currentTransaction: any = null;
  user: any;
  filters: any = {};
  currentConstraints: any = {};
  downloadOn: boolean = false;
  pagination = {
    page: 1,
    elementsPerPage: 10,
    sorting: {
      sort: 'created,desc',
      description: 'Newest Date'
    }
  };
  totalElements: number = 0;
  disabled = false;
  expandedKeys: number = -1;
  TransactionStatus = TransactionStatus;
  OrderStatusEnum = OrderStatusEnum;
  datePicker: any;
  LOCALIZATION: any = {};
  @ViewChild('blockUIWrapper') blockUIWrapper!: BlockUIWrapperComponent;
  @ViewChild('printTransactionTemplate', { static: false }) printTransactionTemplate!: TemplateRef<any>;
  @ViewChild('printTransactionsTemplate', { static: false }) printTransactionsTemplate!: TemplateRef<any>;
  
  private userServiceSubscription: Subscription = new Subscription();
  private cartUpdatedSubscription: Subscription = new Subscription();
  
  sortingOptions: any[] = [
  { sort: 'created,desc', description: 'Date - Newest' },
  { sort: 'created,asc', description: 'Date - Oldest' },
  { sort: 'uuid,desc', description: 'Order # - Highest' },
  { sort: 'uuid,asc', description: 'Order # - Lowest' },
  { sort: 'amount,desc', description: 'Total - Highest' },
  { sort: 'amount,asc', description: 'Total - Lowest' }
  ];
  constructor(
    private transactionService: CartTransactionService,
    private userService: UserService,
    private alertsService: AlertsService,
    private utilsService: UtilsService,
    private cartService: CartService,
    private renderer: Renderer2,
    private el: ElementRef,
    private viewContainerRef: ViewContainerRef
  ) {
	  console.log(this.blockUIWrapper);
  }
  
  ngOnInit(): void {
    this.user = this.userService.user;
    this.LOCALIZATION = this.userService.LOCALIZATION;
    this.initFields();
    // Subscribe to user preferences update
    this.userServiceSubscription = this.userService.broadcastEvent.subscribe((eventId: string) => {
      if("userPrefsUpdate" === eventId){
      	this.user = this.userService.user;
      	this.initFields();
      } else if("localizationLoaded" === eventId){
		  this.LOCALIZATION = this.userService.LOCALIZATION;
	  }
    });
    
    // Subscribe to cart updates
    /*this.cartUpdatedSubscription = this.cartService.broadcastEvent.subscribe((eventId: string) => {
      *if("expandedKeysUpdated" === eventId){
		  this.expandedKeys = this.cartService.getExpandedKeys();
	  }
    });*/
  }
  ngAfterViewInit(): void {
	  if (this.blockUIWrapper) {
	    console.log(this.blockUIWrapper);
	  }
  }
  ngOnDestroy(): void {
    // Clean up subscriptions
    if (this.userServiceSubscription) {
      this.userServiceSubscription.unsubscribe();
    }
    /*if (this.cartUpdatedSubscription) {
      this.cartUpdatedSubscription.unsubscribe();
    }*/
  }
  openDatePicker(id: string): void {
	  if (!this.datePicker) {
		  let opts = this.userService.getDatePickerOptions();
		  opts.mode = "range";	
		  delete opts.defaultDate;
		  const element = this.el.nativeElement.querySelector('#'+id); // Get the element
		  this.datePicker = flatpickr(element, opts);
	  }
	  if (this.datePicker.isOpen) {
		  this.datePicker.close();
	  } else {
		  this.datePicker.open();
	  }
  }
  
  downloadPage(url: string): void {
    this.alertsService.info({
      title: this.LOCALIZATION.downloadStarted,
      message: this.LOCALIZATION.processingWaitMessage,
      delay: 10000
    });
    window.open(url, '_blank');
  }

  downloadOrder(uuid: string, pdf: boolean): void {
    this.alertsService.info({
      title: this.LOCALIZATION.downloadStarted,
      message: this.LOCALIZATION.processingWaitMessage,
      delay: 10000
    });
    this.transactionService.downloadTransaction(uuid, null, pdf);
  }

  initTransactions(): void {
	if(this.blockUIWrapper){
    	this.blockUIWrapper.start('Loading transactions...');
    }
    this.transactionService.getTransactions(this.pagination.page - 1, this.pagination, this.currentConstraints).then(
      pagedResponse => {
        this.transactions = pagedResponse.content;
        this.pagination.elementsPerPage = pagedResponse.size;
        this.totalElements = pagedResponse.totalElements;
        this.pagination.page = pagedResponse.number + 1;
        if(this.blockUIWrapper){
        	this.blockUIWrapper.stop();
        }
      }).catch((e) => {
        console.error('Failed to retrieve transactions');
        if(this.blockUIWrapper){
        	this.blockUIWrapper.stop();
        }
      });
  }

  filter(): void {
    if (this.datePicker && this.datePicker.selectedDates && this.datePicker.selectedDates.length >0) {
		let [start, end] = this.datePicker.selectedDates;
		if (!end) end = new Date(start.getTime());
		start.setHours(0, 0, 0, 0);
		end.setHours(23, 59, 59, 999);				
		this.filters.startDate = start.getTime();
		this.filters.endDate = end.getTime();
	}
			
    this.currentConstraints = {
        uuid: this.filters.uuid,
        beginCreatedDate: this.filters.startDate,
        endCreatedDate: this.filters.endDate,
        minAmount: this.filters.minAmount,
        maxAmount: this.filters.maxAmount
      };
      this.pagination.page = 1;
      this.initTransactions();
    }
  clear(): void {
    this.filters = {};
    this.currentConstraints = {};
    this.initTransactions();
  }

  pageChanged(): void {
    this.initTransactions();
  }

  pageSizeChanged(size: number): void {
    this.pagination.elementsPerPage = size;
    this.pagination.page = 1;
    this.initTransactions();
  }

  sortingChanged(sortObj: any): void {
    this.pagination.sorting = sortObj;
    this.pagination.page = 1;
    this.initTransactions();
  }

  initFields(): void {
	if (!this.user?.permissions) {
       return;
    }
    let permissions = this.userService.getUserPermissionsMap();  
    if (permissions['ROLE_PRODUCT_DOWNLOAD']) {
        this.downloadOn = false;
    } else {
        if (permissions["ROLE_TRANSACTION_HISTORY"]) {
            this.downloadOn = true;
            this.initTransactions();
        } else { //kiosk;
            this.downloadOn = false;
        }
    }
  }
  
  getExpandedKeys(): number {
	return this.expandedKeys;
  }

  setExpandedKeys(expandedKeys: unknown): void {
	  this.expandedKeys = this.utilsService.isString(expandedKeys) ? Number(expandedKeys) : -1;
  }
  
  /*printTransaction(data: any): void {
    const templateUrl = '/app/cart/cart/order-detail.html';  // Adjust path as needed

    this.http.get(templateUrl, { responseType: 'text' }).subscribe(
      (template) => {
        const sanitizedTemplate = this.sanitizer.bypassSecurityTrustHtml(template);
        const element = document.createElement('div');
        element.innerHTML = sanitizedTemplate as string;

        this.waitForRenderAndPrint(element, data);
      },
      (error) => console.error('Error loading template:', error)
    );
  }
  
  private waitForRenderAndPrint(element: HTMLElement, data: any): void {
    setTimeout(() => {
      if (document.readyState !== 'complete') {
        this.waitForRenderAndPrint(element, data);
      } else {
        this.printHtml(element.innerHTML);
      }
    }, 100);
  }*/
  printTransaction(transaction: PrettyCartTransaction): void {
	if (!this.printTransactionTemplate) {
      console.error('printTemplate is undefined!');
      return;
    }
    const embeddedView = this.viewContainerRef.createEmbeddedView(this.printTransactionTemplate, { $implicit: transaction });
    embeddedView.detectChanges();
    const htmlContent = embeddedView.rootNodes.map(node => node.outerHTML).join('');
    
    const styles = Array.from(document.querySelectorAll('style'))
    .map(style => style.outerHTML)
    .join('');
    
    const fullHtml = `<html><head>${styles}</head><body>${htmlContent}</body></html>`;
    this.printHtml(fullHtml);
    
    // Remove the embedded view to avoid displaying it on the main page
    this.viewContainerRef.clear();
  }
  
  printTransactions(transactions: PrettyCartTransaction[]): void {
	if (!this.printTransactionsTemplate) {
      console.error('printTemplate is undefined!');
      return;
    }
    const embeddedView = this.viewContainerRef.createEmbeddedView(this.printTransactionsTemplate, { $implicit: transactions });
    embeddedView.detectChanges();
    const htmlContent = embeddedView.rootNodes.map(node => node.outerHTML).join('');
    
    const styles = Array.from(document.querySelectorAll('style'))
    .map(style => style.outerHTML)
    .join('');
    
    const fullHtml = `<html><head>${styles}</head><body>${htmlContent}</body></html>`;
    this.printHtml(fullHtml);
    
    // Remove the embedded view to avoid displaying it on the main page
    this.viewContainerRef.clear();
  }

  private printHtml(html: string): void {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.print();
    }
  }
}